import { createFeatureSelector, createSelector } from '@ngrx/store';
import { RouterReducerState } from '@ngrx/router-store';
import { RootState } from '../../../app/store/store.state';

export const selectRouter = createFeatureSelector<
    RootState,
    RouterReducerState
>('router');

export const getRouterState = (state: RootState) => state.router;

export const getCurrentUrl = createSelector(
    getRouterState,
    (state: RouterReducerState) => state.state.url
);

export const selectCurrentPageState = createSelector(
    getRouterState,
    (state: RouterReducerState) => state.state && state.state.url
);
